<template>
  <div class="section-container">
    <div class="pbg" :style="{ backgroundImage: 'url(' + bgImage + ')' }"></div>
    <div class="se-hero__overlay">
      <div class="l-content">
        <div class="row">
          <div class="col-xs-16 col-xs-offset-1">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeSection',
  props: [
    'bgImage',
    'hiResSrc',
    'loResSrc',
    'chapter',
    'section',
    'title',
    'grayBG'
  ],
  data () {
    return {
      currentSrc: null
    }
  },
  mounted () {
  },
  methods: {
    scrollDown () {
      const targetEl = this.$el.nextElementSibling
      if (targetEl) {
        this.$scrollTo(targetEl, 1000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/scss/vars';

.section-container {
  position: relative;
  display: block;
  min-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
  .pbg {
    height: 125%;
    position: absolute;
    top: -50%;
    width: 100%;
    background-size: cover;
    background-position: center;
    // background-attachment: fixed;
  }

  .se-hero__overlay {
    z-index: 1;
    background: linear-gradient(to right, rgba(0,0,0,.6) 0%, rgba(0,0,0,.1) 100%);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    @media(min-width: 768px) {
      background: linear-gradient(to right, rgba(0,0,0,.6) 0%, rgba(0,0,0,0) 70%);
    }
  }
  h2 {
    font-size: 32px;
    line-height: 40px;
    color: #FFF;
    @media(min-width:768px) {
      font-size: 72px;
      line-height: 80px;
    }

    letter-spacing: .04rem;
    margin-bottom: 30px;
  }
  p {
    color: #fff;
    max-width: 75%;
    margin-bottom: 50px;
    @media(min-width: 768px) {
      max-width: 50%;
    }
  }
  button {
    font-size: 15px;
    @media(min-width: 768px) {
      font-size: 16px;
    }
  }
}

  .se-hero {
    position: relative;
    height: calc(100vh - 80px);
    min-height: 320px;
    width: 100%;
    background-color: #333333;

    &__overlay {
      background: linear-gradient(to top, rgba(0,0,0,.6) 0%, rgba(0,0,0,0) 50%);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeSection.vue